import type { Activity, DashboardNotification } from '@/types'

// Recent events for the overview feed and the notification menu. They refer to the
// hand written customers in data/customers.ts so names and statuses line up.

export const ACTIVITIES: Activity[] = [
    {
        id: 'act-01',
        type: 'upgrade',
        title: 'Kopi Senja Nusantara naik ke paket Scale',
        description: '24 pengguna, tagihan bulanan',
        time: '12 menit lalu'
    },
    {
        id: 'act-02',
        type: 'new',
        title: 'Klinik Gigi Senyum Sehat mulai berlangganan',
        description: 'Paket Growth dengan 7 pengguna',
        time: '48 menit lalu'
    },
    {
        id: 'act-03',
        type: 'payment-failed',
        title: 'Pembayaran CV Maju Bersama Logistik gagal',
        description: 'Virtual account kedaluwarsa, akan dicoba lagi besok',
        time: '1 jam lalu'
    },
    {
        id: 'act-04',
        type: 'trial',
        title: 'Kafe Langit Biru memulai trial 14 hari',
        description: 'Mencoba paket Growth',
        time: '3 jam lalu'
    },
    {
        id: 'act-05',
        type: 'team',
        title: 'Laras Kusuma menghubungi PT Mitra Tekstil Priangan',
        description: 'Menjadwalkan sesi peninjauan akun',
        time: '5 jam lalu'
    },
    {
        id: 'act-06',
        type: 'churn',
        title: 'Warung Tani Digital membatalkan langganan',
        description: 'Alasan: usaha sedang berhenti sementara',
        time: 'Kemarin'
    }
]

export const NOTIFICATIONS: DashboardNotification[] = [
    {
        id: 'ntf-01',
        type: 'payment-failed',
        title: 'Pembayaran gagal',
        description: 'Tagihan CV Maju Bersama Logistik belum terbayar.',
        time: '1 jam lalu',
        href: '/langganan?status=failed',
        read: false
    },
    {
        id: 'ntf-02',
        type: 'new',
        title: 'Pelanggan baru',
        description: 'Klinik Gigi Senyum Sehat memilih paket Growth.',
        time: '48 menit lalu',
        href: '/pelanggan?q=Klinik%20Gigi%20Senyum%20Sehat',
        read: false
    },
    {
        id: 'ntf-03',
        type: 'risk',
        title: 'Akun berisiko',
        description: 'Skor kesehatan PT Mitra Tekstil Priangan turun ke 38.',
        time: '4 jam lalu',
        href: '/pelanggan?q=PT%20Mitra%20Tekstil%20Priangan',
        read: false
    },
    {
        id: 'ntf-04',
        type: 'report',
        title: 'Laporan Oktober siap',
        description: 'Ringkasan pendapatan dan retensi bulan lalu sudah tersedia.',
        time: 'Kemarin',
        href: '/analitik',
        read: true
    },
    {
        id: 'ntf-05',
        type: 'team',
        title: 'Undangan tim menunggu',
        description: 'Reza Hakim belum menerima undangan bergabung.',
        time: '2 hari lalu',
        href: '/tim',
        read: true
    }
]
